export const APP_PATH = {
  // Lab Authentication
  login: "/api/v1/lab/login",
  refreshToken: "/api/v1/lab/refresh-token",
  logout: "/api/v1/lab/logout",
  validateToken: "/api/v1/auth/validate-token",

  // Lab-specific endpoints
  getConsultation: "/api/v1/consultation/me",
  getDocument: "/api/v1/consultation/documents/my-documents",
  forgotPassword: "/api/v1/consultation/forgot-password",
  resetPassword: "/api/v1/consultation/reset-password",
  forgotPasswordSendOtp: "/api/v1/lab/forgot-password/send-otp",
  forgotPasswordVerifyOtp: "/api/v1/lab/forgot-password/verify-otp",
  forgotPasswordReset: "/api/v1/lab/forgot-password/reset",
  changePassword: "/api/v1/lab/change-password",
  uploadAvatar: "/api/v1/media/upload-avatar",
  labProfile: "/api/v1/lab/profile",

  // Regions catalog (governorate-level)
  regions: "/api/v1/auth/regions",

  // Patient endpoints (if needed for lab operations)
  verifyOtp: "/api/v1/auth/patient/verify-otp",
  resendOtp: "/api/v1/auth/patient/resend-otp",
  getPatientDetails: "/api/v1/consultation/patient/details",
  // Lightweight chat participant lookup (name + presigned avatar by user id) —
  // used by the global ChatDock header on any screen (incl. general chats).
  chatParticipant: "/api/v1/consultation/chat/participant",

  // Notifications
  getUserNotifications: "/api/v1/notification/user",
  markNotificationRead: "/api/v1/notification",
  deleteNotification: "/api/v1/notification",
  getUnreadNotificationCount: "/api/v1/notification/unread-count",
  markAllNotificationsRead: "/api/v1/notification/mark-all-read",

  // Insurance endpoints (for lab claims)
  insuranceLogin: "/api/v1/insurance/login",
  insurancelogout: "/api/v1/insurance/logout",
  medicalOrders: "/api/v1/insurance/claims/medical-orders",
  labTests: "/api/v1/insurance/claims/lab-tests",
  statistics: "/api/v1/insurance/claims/statistics",
  history: "/api/v1/insurance/claims/history",
  claims: "/api/v1/insurance/claims/{claimId}",
  verify: "/api/v1/insurance/claims/{claimId}/verify",
  claimsReject: "/api/v1/insurance/claims/{claimId}/reject",
  claimsApproveItem: "/api/v1/insurance/claims/{claimId}/approve-item",
  claimsRejectItem: "/api/v1/insurance/claims/{claimId}/reject-item",
  claimsCalculate: "/api/v1/insurance/claims/{claimId}/calculate",
  claimsinvoice: "/api/v1/insurance/claims/{claimId}/invoice",
  claimsexport: "/api/v1/insurance/claims/export",
  claimsdocuments: "/api/v1/insurance/claims/{claimId}/documents",

  // Pharmacy endpoints (if needed for lab operations)
  getPharmacyOrders: "/api/v1/pharmacy/orders",
  confirmPharmacyOrder: "/api/v1/pharmacy/orders",
  searchPharmacyMedicines: "/api/v1/pharmacy/medicines/search",

  // Lab Orders endpoints - FIXED: Use consistent path
  getLabOrders: "/api/v1/lab/orders",
  labOrders: "/api/v1/lab/orders",
  exportLabOrders: "/api/v1/lab/orders/export",
  addOrderTests: "/api/v1/lab/orders", // For POST /:id/tests
  uploadResults: "/api/v1/lab/orders", // For POST /:id/upload-results
  uploadResultsMultipart: "/api/v1/lab/orders", // For POST /:id/upload-results-multipart
  uploadMultipleResults: "/api/v1/lab/orders", // For POST /:id/upload-multiple-results
  getFilePresignedUrl: "/api/v1/lab/orders", // For GET /:id/file/:fileId/presigned-url
  deleteTestResultFile: "/api/v1/lab/orders", // For DELETE /:id/file/:fileId

  // Lab Reports endpoints
  getLabReports: "/api/v1/lab/reports", // For GET /
  getReportDetails: "/api/v1/lab/reports", // For GET /:id
  resendReport: "/api/v1/lab/reports", // For POST /:id/resend

  // Lab Services endpoints (for managing test catalog)
  labServices: "/api/v1/lab/services",

  // Lab Technicians endpoints
  labTechnicians: "/api/v1/lab/technicians",

  // Lab Earnings endpoints
  labEarningsSummary: "/api/v1/lab/earnings/summary",
  labEarnings: "/api/v1/lab/earnings",
  labEarningsExport: "/api/v1/lab/earnings/export",

  // Lab Orders Dashboard endpoints
  labOrdersPending: "/api/v1/lab/orders/pending",
  labOrdersOngoing: "/api/v1/lab/orders/ongoing",
  labOrdersMetrics: "/api/v1/lab/orders/metrics/dashboard",

  // Admin-configured reject-order reasons for this center (dropdown on the
  // Reject Order dialog). Requires ?service_type=lab
  providerRejectionReasons: "/api/v1/provider/rejection-reasons",

  // Public endpoints (no authentication required)
  publicOrderDetails: "/api/v1/public/lab/orders",
  publicAppointmentDetails: "/api/v1/public/appointments",
  publicAppointmentWorkflow: "/api/v1/public/appointments",

  // On-site order workflow
  onsiteOrderWorkflow: "/api/v1/lab/orders",

  // Chat with Admin
  consultationChatMessages: "/api/v1/consultation/chat/messages",
  consultationChatMarkRead: "/api/v1/consultation/chat/mark-read",
  consultationChatUnreadCount: "/api/v1/consultation/chat/unread-count",
  consultationChatRooms: "/api/v1/consultation/chat/rooms",
  consultationChatUpload: "/api/v1/consultation/chat/upload",
  consultationChatDownload: "/api/v1/consultation/chat/download",

  // Settlement / Payout Account (payment-service) — generic provider endpoints
  submitSettlementRequest: "/api/v1/payment/settlements/request",
  getProviderSettlements: "/api/v1/payment/settlements",
  getSettlementDashboard: "/api/v1/payment/settlements/dashboard",
  payoutAccounts: "/api/v1/payment/payout-accounts",
  getDefaultPayoutAccount: "/api/v1/payment/payout-accounts/default",
};
